export const EMP_PREFIX = "ACS-";
export const CDN_URL = "https://cdn.acsdev.in/acs_hrms";
export const QR_LINK = "https://acsdev.in/facerecognition";

// Production url
export const BASE_URL = "https://hrmsbackend.algorithmicaconsulting.com/api";

// Testing url
// export const BASE_URL = "https://hrmsbackendtest.algorithmicaconsulting.com/api";

// Local
// export const BASE_URL = "http://localhost/hrms/api";
